<template>


  <form
    @submit.prevent="onSubmit"
    class="form form_career"
    novalidate
  >

    <slot :verified="verified"></slot>


    <transition
    name="v04"
    :duration="800">
      <div
        class="message message_form-sent"
        v-if="successfullySent"
      >
        <img class="message__icon" alt="messageIcon" src="/static/success.svg"/>
        <p class="message__text">Grazie per le informazioni. Sei entrata/o nel nostro data base. Ti contatteremo appena avremo opportunità nella tua area di lavoro.</p>

      </div>
    </transition>


  </form>


</template>

<script>
  import $ from 'jquery';

  export default {
    name: 'FormContainer',

    data() {
      return {
        successfullySent: null,
        verified: null,
        sending: false,
      };
    },

    created() {
      this.$on('fixed', this.onFixed);
    },

    methods: {
      onSubmit() {
        this.checkFields();

        const formData = new FormData();

        formData.append('first_name', this.$children[0].value);
        formData.append('last_name', this.$children[1].value);
        formData.append('phone', this.$children[2].value);
        formData.append('email', this.$children[3].value);
        formData.append('region', this.$children[4].value);
        formData.append('city', this.$children[5].value);
        formData.append('vakancy', this.$children[6].value);

        $.each(this.$children[7].value, function(obj, v) {
          formData.append('file[]', v);
        });

        if (this.verified && !this.sending) {
          this.sending = true;
          $('.button_form-career-page').prop('disabled', true);
          this.$http.post('/career/request/add', formData, {
            headers: {
              'Content-Type': 'multipart/form-data',
            },
          })
          .then(this.onFulfilled)
          .catch((res) => {});
        }
      },

      checkFields() {
        let verified = true;

        this.$children.forEach((item) => {
          if (!item.filled && item.required) {
            verified = false;
            this.$set(item, 'mustFilled', true);
          }

          if (item.name === 'phone' && item.value) {
            if (item.value.replace(/[0-9+\-)( ]/g, '').trim() !== '') {
                verified = false;
                this.$set(item, 'mustFilled', true);
            }
          }

          if (item.name === 'email') {
            if (this.isEmail(item.value)) {
                verified = false;
                this.$set(item, 'mustFilled', true);
            }
          }
        });

        this.verified = verified;
      },

      isEmail(email) {
          const re = /\S+@\S+\.\S+/;
          return !re.test(email);
      },

      onFixed() {
        this.checkFields();
      },

      onFulfilled(res) {
        this.sending = false;
        $('.button_form-career-page').prop('disabled', false);
        this.successfullySent = true;
        setTimeout(() => {
          this.onClickLinkWriteMore();
        }, 3000);
      },

      onClickLinkWriteMore() {
        this.successfullySent = null;
      },
    },
  };
</script>



// WEBPACK FOOTER //
// src/components/FormContainer.vue